/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Features_SubInputs */

const en_mk_features_sub = /** @type {(inputs: Mk_Features_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From the first decision to ongoing maintenance. Open the guides to see how each capability works.`)
};

const id_mk_features_sub = /** @type {(inputs: Mk_Features_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dari keputusan pertama sampai pemeliharaan. Buka panduan untuk melihat cara menggunakan setiap kemampuan.`)
};

/**
* | output |
* | --- |
* | "From the first decision to ongoing maintenance. Open the guides to see how each capability works." |
*
* @param {Mk_Features_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_features_sub = /** @type {((inputs?: Mk_Features_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Features_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_features_sub(inputs)
	return en_mk_features_sub(inputs)
});